import React, { useCallback } from "react";
import { Checkbox } from "semantic-ui-react";
import styled from "styled-components";

const Holder = styled.div`
    padding: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Box = styled.div`
    display: flex;
    margin-left: 3.5em;
    justify-content: space-between;
    background-color: rgba(0,0,0,0.8);
    border: 1px solid black;
    width: 200px;
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    background: linear-gradient(rgb(255,255,255), rgba(255,255,255,0.2));
    width: 40%;
`;

const Cell = styled.div`
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1em;
    height: 4em;
    &:not(:last-child) {
        border-bottom: 1px solid black;
    }
`;

const CellLabeled = styled(Cell)`
    ::before {
        position: absolute;
        left: -3.5em;
        content: attr(label);
        font-weight: bold;
    }
`;

const Test5 = ({ view, setStpForm, id }) => {
    const onChange = useCallback((e, { name, checked }) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev };

            newStpForm.data.forEach((item) => {
                if (item.STPTestView === view.STPTestView) {
                    item[name] = checked;
                }
            });

            return newStpForm;
        });
    }, [view]);

    return (
        <Holder id={id}>
            <Box>
                <Column>
                    <CellLabeled label='14mm' />
                    <CellLabeled label='16mm' />
                    <CellLabeled label='18mm' />
                    <CellLabeled label='20mm' />
                    <CellLabeled label='22mm' />
                    <CellLabeled label='24mm' />
                    <CellLabeled label='26mm' />
                    <CellLabeled label='28mm' />
                    <CellLabeled label='30mm' />
                </Column>
                <Column>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_14`}
                            onChange={onChange}
                            checked={view.STPTest5_14}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_16`}
                            onChange={onChange}
                            checked={view.STPTest5_16}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_18`}
                            onChange={onChange}
                            checked={view.STPTest5_18}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_20`}
                            onChange={onChange}
                            checked={view.STPTest5_20}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_22`}
                            onChange={onChange}
                            checked={view.STPTest5_22}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_24`}
                            onChange={onChange}
                            checked={view.STPTest5_24}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_26`}
                            onChange={onChange}
                            checked={view.STPTest5_26}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_28`}
                            onChange={onChange}
                            checked={view.STPTest5_28}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            name={`STPTest5_30`}
                            onChange={onChange}
                            checked={view.STPTest5_30}
                        />
                    </Cell>
                </Column>
            </Box>
        </Holder>
    );
}

export default Test5;
